import React from "react";
import { MinimalTiptap } from "../../ui/MinimalTap";

type IRichTextEditor = {
  label?: string;
  value: string;
  onChange: (content: string) => void;
  error?: string;
};

const RichTextEditor: React.FC<IRichTextEditor> = ({
  label,
  value,
  onChange,
  error,
}) => {
  const handleChange = (content: string) => {
    onChange(content);
  };

  return (
    <div className="w-full flex flex-col gap-2">
      {label && <label className="font-medium">{label}</label>}

      <MinimalTiptap
        content={value}
        onChange={handleChange}
        placeholder="Your message here..."
      />

      {error && <p className="text-red-500 text-xs">{error}</p>}
    </div>
  );
};

export default RichTextEditor;
